
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider"; // Import this!
import Navbar from "./components/Navbar";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import ReferralTree from "./pages/ReferralTree";
import Commissions from "./pages/Commissions";
import Profile from "./pages/Profile";
import Login from "./pages/Login";
import RegisterPage from "./pages/RegisterPage";
import ReferralPage from "./pages/ReferralPage";
import ProtectedRoute from "./components/ProtectedRoute";
import MobileSidebar from "./components/MobileSidebar";
import CoursesToPromote from "./pages/CoursesToPromote";
import ToastHost from "./components/ToastHost";

function App() {
  const { user, userData } = useAuth();

  return (
    <Router>
      <ToastHost />
      {user && userData && (
        <div className="hidden md:block">
          <Navbar />
        </div>
      )}
      {user && userData && <MobileSidebar />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* All protected routes below */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/products"
          element={
            <ProtectedRoute>
              <Products />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tree"
          element={
            <ProtectedRoute>
              <ReferralTree />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commissions"
          element={
            <ProtectedRoute>
              <Commissions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile userData={userData} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/referral"
          element={
            <ProtectedRoute>
              <ReferralPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses-to-promote"
          element={
            <ProtectedRoute>
              <CoursesToPromote />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
